export default __webpack_public_path__ + "static/media/arrow-left.f1304a66.svg";